import React, { useState, useEffect, useRef, Fragment } from "react";
import { Dialog } from "primereact/dialog";
import { Image } from 'primereact/image';
import sideBarRight from "../../../assets/images/sidebarright.svg";
import { Tag } from 'primereact/tag';
import { useReactToPrint } from "react-to-print";
import moment from 'moment/moment';
import ReportTemplate from "../ReportTemplate";
import { InputText } from "primereact/inputtext";
import { CertificatedSubInitiateRequest, CertificatedSubRequestFundingAccountDetails, CertificatedSubRequestSpecificTeacherDates, CertificatedSubRequestTeacherData, CertificatedSubRequestTransactionCycle, Employee, FundingAccountType } from "../../../models";
import { DataStore, Predicates, SortDirection } from "aws-amplify";
import { toast } from 'react-toastify';
import { reactLocalStorage } from 'reactjs-localstorage';
import { ProgressSpinner } from 'primereact/progressspinner';
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import { handleNotificationsOnStatusChangeforSubstituteRequestCertificated } from '../../../components/actions/notficationActions';
import { Timeline } from 'primereact/timeline';
import AWS from "aws-sdk";
import { GetValueFromArray, graphQLGetAllData, graphQLFindRecordById } from '../../../helper/commonfunctions';
import awsmobile from "../../../aws-exports";
import handleDateSelect from '../../../helper/convertDateIntoPSTFormat';
import { API, graphqlOperation } from 'aws-amplify';
import * as mutations from '../../../graphql/mutations';
import { Dropdown } from "primereact/dropdown";
import { useNavigate } from 'react-router-dom';

const EditPopupRequestedReport = (props) => {

    let [allEmployees, setAllEmployees] = useState([]);
    let navigateTo = useNavigate();

    let [events, setEvents] = useState([]);
    let [submittedBy, setSubmittedBy] = useState({});
    let [createdDate, setCreatedDate] = useState('');
    console.log(createdDate, 'createdDate')
    let [isLoadData, setIsLoadData] = useState(false);
    const [globalReportId, setReportId] = useState('');
    const [schoolOrDeptName, setSchoolOrDeptName] = useState('');
    const [requestDate, setRequestDate] = useState('');
    const [status, setStatus] = useState('');
    const [specifyPurpose, setSpecifyPurpose] = useState('');
    const [approvalFinalData, setApprovalFinalData] = useState([]);
    const [approveDisable, SetApproveDisable] = useState(false);

    const getInformationOfParticularReport = async (reportId) => {

        const allEmployees = await graphQLGetAllData("listEmployees");
        setAllEmployees(allEmployees);

        const cognito = new AWS.CognitoIdentityServiceProvider();

        //get teacher data from CertificatedSubRequestTeacherData table
        // var certificatedSubRequestTeacherDataResponses = await DataStore.query(CertificatedSubRequestTeacherData, (c) => c.reportId.eq(reportId));

        var certificatedSubRequestTeacherDataResponses = await graphQLGetAllData("listCertificatedSubRequestTeacherData", [{ reportId: { eq: reportId } }])

        let teacherDetails = [];
        for (let i = 0; i < certificatedSubRequestTeacherDataResponses.length; i++) {

            //get dates of that particular teacher from CertificatedSubRequestSpecificTeacherDates 
            // var certificatedSubRequestSpecificTeacherDatesResponses = await DataStore.query(CertificatedSubRequestSpecificTeacherDates, (c) => c.teacherId.eq(certificatedSubRequestTeacherDataResponses[i].id));

            var certificatedSubRequestSpecificTeacherDatesResponses = await graphQLGetAllData("listCertificatedSubRequestSpecificTeacherDates", [{ teacherId: { eq: certificatedSubRequestTeacherDataResponses[i].id } }])

            // var employeeResponses = await DataStore.query(Employee, (c) => c.id.eq(certificatedSubRequestTeacherDataResponses[i].teacherId));

            var employeeResponses = await graphQLFindRecordById("getEmployee", certificatedSubRequestTeacherDataResponses[i].teacherId)


            let dateArray = [];
            for (let j = 0; j < certificatedSubRequestSpecificTeacherDatesResponses.length; j++) {
                dateArray.push(certificatedSubRequestSpecificTeacherDatesResponses[j].date);
            }

            let obj = {
                teacherName: employeeResponses.employee_name,
                datesNeeded: dateArray,
                indicateIf: certificatedSubRequestTeacherDataResponses[i].indicateIf,
                gradeOrSubject: certificatedSubRequestTeacherDataResponses[i].gradeOrSubject,
                notes: certificatedSubRequestTeacherDataResponses[i].note
            }
            teacherDetails.push(obj);
        }
        teacherDetails = teacherDetails.sort((a, b) => a.teacherName.localeCompare(b.teacherName));
        setReportInformation(teacherDetails);

        try {
            // const certificatedSubRequestFundingAccountDetailsResponses = await DataStore.query(CertificatedSubRequestFundingAccountDetails, (c) => c.reportId.eq(reportId));
            let certificatedSubRequestFundingAccountDetailsResponses = await graphQLGetAllData("listCertificatedSubRequestFundingAccountDetails", [{ reportId: { eq: reportId } }])
            certificatedSubRequestFundingAccountDetailsResponses = certificatedSubRequestFundingAccountDetailsResponses.sort((a, b) => a.createdAt.localeCompare(b.createdAt));


            let fundingDetails = [];

            for (let i = 0; i < certificatedSubRequestFundingAccountDetailsResponses.length; i++) {
                const fundingAccountTypeId = certificatedSubRequestFundingAccountDetailsResponses[i].fundingAccountTypeId;
                // const deptNames = await DataStore.query(FundingAccountType, (c) => c.id.eq(fundingAccountTypeId));
                const deptNames = await graphQLFindRecordById("getFundingAccountType", fundingAccountTypeId)
                if (deptNames) {
                    const obj = {
                        departmentName: deptNames?.fundingAccountType, // Use optional chaining
                        programAccountNumber: certificatedSubRequestFundingAccountDetailsResponses[i].accountNumber,
                        remark: certificatedSubRequestFundingAccountDetailsResponses[i].remarks,
                        percentage: certificatedSubRequestFundingAccountDetailsResponses[i].percentage,
                    };

                    fundingDetails.push(obj);
                } else {
                    console.warn(`No department found for fundingAccountTypeId ${fundingAccountTypeId}`);
                }
            }
            setFundingDetails(fundingDetails);
            setIsLoadData(true)
        } catch (error) {
            console.error("Error:", error);
        }

        let currentDateTime = moment();
        currentDateTime = moment(currentDateTime).format("YYYY-MM-DD HH:mm:ss");

        //get particular report transaction cycle data and metadata
        try {
            // const particularReportMetaDataResponse = await DataStore.query(CertificatedSubInitiateRequest,
            //     (c) => c.id.eq(reportId)
            // );

            const particularReportMetaDataResponse = await graphQLFindRecordById("getCertificatedSubInitiateRequest", reportId)
            console.log('particularReportMetaDataResponse', particularReportMetaDataResponse);


            //set Approver level drop down data start.
            //approverLevelForReject
            let initiator = particularReportMetaDataResponse.submittedBy;
            let sitAdminOrDeptHead = particularReportMetaDataResponse?.firstApproverId;
            let budgetClerk = particularReportMetaDataResponse?.secondApproverId;
            let budgetManager = particularReportMetaDataResponse?.thirdApproverId;
            let payroll = particularReportMetaDataResponse?.payrollId;

            const loggedUserId = reactLocalStorage.get('loggedUserId');

            let approverLevelArray = [];
            let approverEmpArray = [];
            let empData = [];
            let objFirst;
            switch (loggedUserId) {
                case sitAdminOrDeptHead:
                    setApproverLevelForReject([
                        { label: "Initiator", value: 1, userSub: initiator }
                    ]);
                    empData = allEmployees.find(el => el?.user_Id === initiator);
                    objFirst = { name: empData?.employee_name, code: initiator, type: "Initiator" };
                    setApproverListForReject([objFirst]);
                    break;

                case budgetClerk:
                    approverLevelArray = [
                        { label: "Initiator", value: 1, userSub: initiator, type: "Initiator" },
                        { label: "Site Admin/Dept. Head", value: 2, userSub: sitAdminOrDeptHead, type: "site/dept" },
                    ]
                    setApproverLevelForReject(approverLevelArray);
                    for (let i = 0; i < approverLevelArray.length; i++) {
                        empData = allEmployees.find(el => el?.user_Id === approverLevelArray[i].userSub);
                        objFirst = { name: empData?.employee_name, code: approverLevelArray[i].userSub, type: approverLevelArray[i].type };
                        approverEmpArray.push(objFirst);
                    }
                    setApproverListForReject(approverEmpArray);
                    break;

                case budgetManager:
                    approverLevelArray = [
                        { label: "Initiator", value: 1, userSub: initiator, type: "Initiator" },
                        { label: "Site Admin/Dept. Head", value: 2, userSub: sitAdminOrDeptHead, type: "site/dept" },
                        { label: "Budget Clerk", value: 3, userSub: budgetClerk, type: "budgetClerk" },
                    ]
                    setApproverLevelForReject(approverLevelArray);
                    for (let i = 0; i < approverLevelArray.length; i++) {
                        empData = allEmployees.find(el => el?.user_Id === approverLevelArray[i].userSub);
                        objFirst = { name: empData?.employee_name, code: approverLevelArray[i].userSub, type: approverLevelArray[i].type };
                        approverEmpArray.push(objFirst);
                    }
                    setApproverListForReject(approverEmpArray);
                    break;

                case payroll:
                    approverLevelArray = [
                        { label: "Initiator", value: 1, userSub: initiator, type: "Initiator" },
                        { label: "Site Admin/Dept. Head", value: 2, userSub: sitAdminOrDeptHead, type: "site/dept" }
                    ]
                    let appArrayWhenBudgetClerkSelect = [];
                    if (budgetClerk) {
                        appArrayWhenBudgetClerkSelect = [
                            { label: "Budget Clerk", value: 3, userSub: budgetClerk, type: "budgetClerk" },
                            { label: "Budget Manager", value: 4, userSub: budgetManager, type: "budgetManager" },
                        ]
                    }
                    approverLevelArray = approverLevelArray.concat(appArrayWhenBudgetClerkSelect);
                    setApproverLevelForReject(approverLevelArray);
                    for (let i = 0; i < approverLevelArray.length; i++) {
                        empData = allEmployees.find(el => el?.user_Id === approverLevelArray[i].userSub);
                        objFirst = { name: empData?.employee_name, code: approverLevelArray[i].userSub, type: approverLevelArray[i].type };
                        approverEmpArray.push(objFirst);
                    }
                    setApproverListForReject(approverEmpArray);
                    break;
            }
            //set Approver level drop down data end.



            // const particularReportTransactionCycleResponse = await DataStore.query(CertificatedSubRequestTransactionCycle,
            //     (c) => c.reportId.eq(reportId),
            //     { sort: s => s.createdAt(SortDirection.ASCENDING) }
            // );

            let particularReportTransactionCycleResponse = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: reportId } }])
            particularReportTransactionCycleResponse = particularReportTransactionCycleResponse.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

            console.log("particularReportTransactionCycleResponse", particularReportTransactionCycleResponse)
            if (particularReportTransactionCycleResponse && particularReportMetaDataResponse) {

                let transactionArray = [];
                //get name of user from 'to_Employee_Id'
                for (let i = 0; i < particularReportTransactionCycleResponse.length; i++) {
                    let empName = '', empCode = '';

                    let adminUsers;
                    if (particularReportTransactionCycleResponse[i].to_Employee_Id) {
                        try {
                            adminUsers = await cognito.adminGetUser({
                                UserPoolId: awsmobile.aws_user_pools_id,
                                Username: particularReportTransactionCycleResponse[i].to_Employee_Id,
                            }).promise();
                        } catch (e) {
                            //console.log(e)
                        }

                        let userFirstName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:firstName") : ''
                        let userLastName = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:lastName") : ''
                        let userCodeEmp = adminUsers ? await GetValueFromArray(adminUsers.UserAttributes, "custom:userCode") : ''
                        let fullName = userFirstName + " " + userLastName

                        let empTitle = '';
                        if (particularReportMetaDataResponse.firstApproverId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            if (particularReportTransactionCycleResponse[i]?.approver_level === "Initiator") {
                                empTitle = "Initiator"
                            } else {
                                empTitle = 'Site Admin/Dept Head';
                            }
                        } else if (particularReportMetaDataResponse?.secondApproverId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Clerk';
                        } else if (particularReportMetaDataResponse?.thirdApproverId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Budget Manager';
                        } else if (particularReportMetaDataResponse?.payrollId == particularReportTransactionCycleResponse[i].to_Employee_Id) {
                            empTitle = 'Sub Desk';
                        } else if (particularReportTransactionCycleResponse[i].status === "RESUBMITTED") {
                            if (particularReportMetaDataResponse?.submittedBy === particularReportTransactionCycleResponse[i].to_Employee_Id) {
                                empTitle = "Initiator"
                            } else {
                                empTitle = "Super Admin"
                            }
                        }
                        else {
                            if (particularReportMetaDataResponse.submittedBy === particularReportTransactionCycleResponse[i].to_Employee_Id) {
                                empTitle = "Initiator"
                            } else {
                                empTitle = (particularReportTransactionCycleResponse[i]?.toEmpDesignation) ? particularReportTransactionCycleResponse[i]?.toEmpDesignation : "Super Admin";
                            }
                        }
            
                        if (i == 0) {
                            let initiatorUsers;

                            try {
                                //get initiator's data using its id
                                initiatorUsers = await cognito.adminGetUser({
                                    UserPoolId: awsmobile.aws_user_pools_id,
                                    Username: particularReportMetaDataResponse.submittedBy,
                                }).promise();
                            } catch (e) {
                                //console.log(e)
                            }

                            let userFirstName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:firstName") : ''
                            let userLastName1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:lastName") : ''
                            let userCodeEmp1 = adminUsers ? await GetValueFromArray(initiatorUsers.UserAttributes, "custom:userCode") : ''
                            let initiatorFullName = userFirstName1 + " " + userLastName1;


                            let obj = {
                                empName: initiatorFullName,
                                empTitle: 'Initiator',
                                empCode: userCodeEmp1,
                                status: 'Submitted',
                                date: (particularReportTransactionCycleResponse[i].createdAt) ? handleDateSelect(particularReportTransactionCycleResponse[i].createdAt) : handleDateSelect(currentDateTime)

                            }
                            setSubmittedBy(obj);
                            transactionArray.push(obj);
                        }
                        // else{
                        //     if(particularReportTransactionCycleResponse[i].status == 'Reviewed & resubmitted' && ){

                        //     }
                        // }

                        console.log('particularReportTransactionCycleResponse[i].status',particularReportTransactionCycleResponse[i].status);


                        let finalStatus = (particularReportTransactionCycleResponse[i].status == 'APPROVED') ? 'Approved' :
                            (particularReportTransactionCycleResponse[i].status == 'CLOSED') ? 'Closed' :
                                (particularReportTransactionCycleResponse[i].status == 'OPEN') ||
                               ( particularReportTransactionCycleResponse[i].status == 'Pending for Approval Budget Clerk')||
                               particularReportTransactionCycleResponse[i].status == 'Pending for Approval Budget Manager'
                                ? 'Pending' :
                                    (particularReportTransactionCycleResponse[i].status == 'REJECTED') ? 'Rejected' :
                                        // (particularReportTransactionCycleResponse[i].status == 'Reviewed & resubmitted') ? 'Pending' :
                                        (particularReportTransactionCycleResponse[i].status == 'Reviewed & resubmitted') ? 'Reviewed & resubmitted' :
                                            particularReportTransactionCycleResponse[i].status;

                        let datetime = particularReportTransactionCycleResponse[i].updatedAt;


                        let obj = {
                            empName: fullName,
                            empTitle: empTitle,
                            status: finalStatus,
                            date: particularReportTransactionCycleResponse[i].status !== 'OPEN' ?
                                ((datetime) ?
                                    moment(datetime).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm ') :
                                    // handleDateSelect(particularReportTransactionCycleResponse[i].updatedAt) : 
                                    moment(currentDateTime).tz('America/Los_Angeles').format('MM/DD/YYYY HH:mm ')) : null,
                            // handleDateSelect(currentDateTime)) 


                            // updatedAt:appDate,
                            isApproved: particularReportTransactionCycleResponse[i].isApproved,
                            //status: (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'CLOSED' ? 'Completed' : (certificatedSubRequestTransactionCycleResponses[certificatedSubRequestTransactionCycleResponses.length - 1].status == 'REJECTED' ? 'Rejected' : (certificatedSubInitiateRequestResponseForApprover[0].status) == 'PENDING' ? 'Pending' : statusReport)),
                            //status: ((particularReportTransactionCycleResponse[i].status) === "SUBMITTED") ? 'Pending For Approval' : particularReportTransactionCycleResponse[i].status
                        }
                        transactionArray.push(obj);
                    }



                }

                console.log("transactionArray:", transactionArray);

                setEvents(transactionArray);

            }
        } catch (err) {
            console.log("Error in particularReportTransactionCycleResponse view popup", err);
        }
    }
    const approveParticularReport = async () => {
        SetApproveDisable(true);
        const loggedUserId = reactLocalStorage.get('loggedUserId');

        console.log('loggedUserId', loggedUserId);

        try {
            //get particular report id metadata from CertificatedSubInitiateRequest table
            // const CertificatedSubInitiateRequestResponse = await DataStore.query(CertificatedSubInitiateRequest, (c) => c.id.eq(globalReportId));

            const CertificatedSubInitiateRequestResponse = await graphQLFindRecordById("getCertificatedSubInitiateRequest", globalReportId)

            //first update CertificatedSubRequestTransactionCycle particular report id entry.
            // const original = await DataStore.query(CertificatedSubRequestTransactionCycle, (c) => c.reportId.eq(globalReportId), {
            //     sort: (s) => s.createdAt(SortDirection.DESCENDING)
            // });

            let original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: globalReportId } }])
            original = original.sort((b, a) => a.createdAt.localeCompare(b.createdAt));


            if (original) {

                if (CertificatedSubInitiateRequestResponse) {
                    let firstApprover = CertificatedSubInitiateRequestResponse.firstApproverId;
                    let secondApprover = CertificatedSubInitiateRequestResponse.secondApproverId;
                    let thirdApprover = CertificatedSubInitiateRequestResponse.thirdApproverId;
                    let payroll = CertificatedSubInitiateRequestResponse.payrollId;
                    let createdBy = CertificatedSubInitiateRequestResponse.submittedBy;

                    let toEmpDesignation="";

                    if(original[0].to_Employee_Id === firstApprover){
                        toEmpDesignation="Site Admin/Dept Head"
                    }else if(original[0].to_Employee_Id === secondApprover){
                        toEmpDesignation="Budget Clerk"
                    }else if(original[0].to_Employee_Id === thirdApprover){
                        toEmpDesignation="Budget Manager"
                    }else if(original[0].to_Employee_Id === payroll){
                        toEmpDesignation="Sub Desk"
                    }

                    //check if logger user is first or second or third approver
                    var toEmployee;
                    var isPayroll = 0;
                    switch (loggedUserId) {
                        case firstApprover:
                            if (secondApprover) {
                                toEmployee = secondApprover;
                            } else {
                                toEmployee = payroll;
                                isPayroll = 1;
                            }
                            break;
                        case secondApprover:
                            if (thirdApprover) {
                                toEmployee = thirdApprover;
                            } else {
                                toEmployee = payroll;
                                isPayroll = 1;
                            }
                            break;
                        case thirdApprover:
                            toEmployee = payroll;
                            // isPayroll = 1;
                            break;
                        default:
                            //means logged in user is Payroll
                            toEmployee = 'no further';
                            break;
                    }

                    if (toEmployee === 'no further') {
                        //means it is payroll
                        let newOriginal = original[0]
                        //patch to hanlde status 
                        if (original[0].status !== 'OPEN') {
                            // const newFetch = await DataStore.query(CertificatedSubRequestTransactionCycle, (c) => c.reportId.eq(globalReportId), {
                            //     sort: (s) => s.createdAt(SortDirection.ASCENDING)
                            // });

                            let newFetch = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: globalReportId } }])
                            newFetch = newFetch.sort((a, b) => a.createdAt.localeCompare(b.createdAt));

                            newOriginal = newFetch.length ? newFetch[newFetch.length - 1] : original[0]
                        }
                        const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        // const updatedPost = await DataStore.save(
                        //     CertificatedSubRequestTransactionCycle.copyOf(newOriginal, updated => {
                        //         updated.status = 'CLOSED';
                        //         updated.isApproved = true;
                        //         updated.customUpdatedAt = currentDateTime;
                        //     })
                        // );

                        console.log("Cycle update-->closed")
                        const updatedPost = await API.graphql({
                            query: mutations.updateCertificatedSubRequestTransactionCycle,
                            variables: {
                                input: {
                                    id: newOriginal.id,
                                    _version: newOriginal._version,
                                    status: 'CLOSED',
                                    isApproved: true,
                                    customUpdatedAt: currentDateTime,
                                    toEmpDesignation: toEmpDesignation
                                }
                            }
                        });


                        setRequestApprovalConfirmVisible(true);
                        await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('ACKNOWLEDGE', globalReportId, "SUBSTITUTE_REQUEST_CERTIFICATED", createdBy, loggedUserId);

                    } else {
                        const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
                        // const updatedPost = await DataStore.save(
                        //     CertificatedSubRequestTransactionCycle.copyOf(original[0], updated => {
                        //         updated.status = 'APPROVED';
                        //         updated.isApproved = true;
                        //         updated.customUpdatedAt = currentDateTime;
                        //     })
                        // );

                        console.log("Cycle update -->Approved")

                        const updatedPost = await API.graphql({
                            query: mutations.updateCertificatedSubRequestTransactionCycle,
                            variables: {
                                input: {
                                    id: original[0].id,
                                    _version: original[0]._version,
                                    status: 'APPROVED',
                                    isApproved: true,
                                    customUpdatedAt: currentDateTime,
                                    toEmpDesignation:toEmpDesignation
                                }
                            }
                        });

                        console.log("cycle updated-->", updatedPost)

                        if (isPayroll === 1) {
                            await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('PAYROLL_ACK', globalReportId, "SUBSTITUTE_REQUEST_CERTIFICATED", toEmployee, createdBy);
                        }
                        else {
                            // AP2 to AP3
                            await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('OPEN', globalReportId, "SUBSTITUTE_REQUEST_CERTIFICATED", toEmployee, createdBy);

                            await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('APPROVEDBY', globalReportId, "SUBSTITUTE_REQUEST_CERTIFICATED", createdBy, loggedUserId);
                        }



                        if (updatedPost.data.updateCertificatedSubRequestTransactionCycle.id) {
                            const currentDateTime2 = moment().format("YYYY-MM-DD HH:mm:ss");
                            //after we add entry in CertificatedSubRequestTransactionCycle table
                            // const CertificatedSubRequestTransactionCycleResponse = await DataStore.save(new CertificatedSubRequestTransactionCycle(
                            //     {
                            //         reportId: globalReportId,
                            //         from_Employee_Id: loggedUserId,
                            //         to_Employee_Id: toEmployee,
                            //         status: 'OPEN',
                            //         isApproved: false,
                            //         customUpdatedAt: currentDateTime2,
                            //     }
                            // ));

                            console.log("Cycle create-->OPEN")
                            let createdRecord = await API.graphql(
                                graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                                    input: {
                                        reportId: globalReportId,
                                        from_Employee_Id: loggedUserId,
                                        to_Employee_Id: toEmployee,
                                        status: 'OPEN',
                                        isApproved: false,
                                        customUpdatedAt: currentDateTime2,
                                        toEmpDesignation:toEmpDesignation
                                    }
                                })
                            );
                            setRequestApprovalConfirmVisible(true);
                        } else {
                            toast.error('Something Went Wrong...');
                        }
                    }
                }
            }
            props.getMasterData();
            SetApproveDisable(true);
            props.setIsLoadData();
        } catch (err) {
            console.log("Error in approveParticularReport :-", err)
        }

        // disable please wait button
        SetApproveDisable(false);
    }
    const rejectParticularReport = async () => {

        if (rejectMsgValue === "") { toast.error('Please Add Reason For Rejection'); return; }
        if (fallBackApprover === null) { toast.error('Please Select an approver level'); return; }

        const loggedUserId = reactLocalStorage.get('loggedUserId');

        //get particular report id metadata from CertificatedSubInitiateRequest table
        // const CertificatedSubInitiateRequestResponse = await DataStore.query(CertificatedSubInitiateRequest, (c) => c.id.eq(globalReportId));
        const CertificatedSubInitiateRequestResponse = await graphQLFindRecordById("getCertificatedSubInitiateRequest", globalReportId)

        //first update CertificatedSubRequestTransactionCycle particular report id entry.
        // const original = await DataStore.query(CertificatedSubRequestTransactionCycle, (c) => c.reportId.eq(globalReportId), {
        //     sort: (s) => s.createdAt(SortDirection.DESCENDING)
        // });

        let original = await graphQLGetAllData("listCertificatedSubRequestTransactionCycles", [{ reportId: { eq: globalReportId } }])
        original = original.sort((b, a) => a.createdAt.localeCompare(b.createdAt));
        if (original) {



            if (CertificatedSubInitiateRequestResponse) {
                // let firstApprover = CertificatedSubInitiateRequestResponse.firstApproverId;
                // let secondApprover = CertificatedSubInitiateRequestResponse.secondApproverId;
                // let thirdApprover = CertificatedSubInitiateRequestResponse.thirdApproverId;
                // let payroll = CertificatedSubInitiateRequestResponse.payrollId;


                    let firstApprover = CertificatedSubInitiateRequestResponse.firstApproverId;
                    let secondApprover = CertificatedSubInitiateRequestResponse.secondApproverId;
                    let thirdApprover = CertificatedSubInitiateRequestResponse.thirdApproverId;
                    let payroll = CertificatedSubInitiateRequestResponse.payrollId;
                    let createdBy = CertificatedSubInitiateRequestResponse.submittedBy;

                    let toEmpDesignation="";

                    if(original[0].to_Employee_Id === firstApprover){
                        toEmpDesignation="Site Admin/Dept Head"
                    }else if(original[0].to_Employee_Id === secondApprover){
                        toEmpDesignation="Budget Clerk"
                    }else if(original[0].to_Employee_Id === thirdApprover){
                        toEmpDesignation="Budget Manager"
                    }else if(original[0].to_Employee_Id === payroll){
                        toEmpDesignation="Sub Desk"
                    }

                    // let createdBy = CertificatedSubInitiateRequestResponse.submittedBy;

                //     //check if logger user is first or second or third approver
                //     var statusValue;
                //     switch (loggedUserId) {
                //         case firstApprover:
                //             statusValue='Rejected from FA'
                //             break;
                //         case secondApprover:
                //             statusValue='Rejected from SA'
                //             break;
                //         case thirdApprover:
                //             statusValue='Rejected from TA'
                //             break;
                //         default:
                //             //means logged in user is Payroll
                //             statusValue = 'no further';
                //             break;
                //     }
                // }
                const currentDateTime = moment().format("YYYY-MM-DD HH:mm:ss");
                // const updatedPost = await DataStore.save(
                //     CertificatedSubRequestTransactionCycle.copyOf(original[0], updated => {
                //         updated.status = 'REJECTED';
                //         updated.remark = rejectMsgValue;
                //         updated.customUpdatedAt = currentDateTime;
                //     })
                // );

                console.log('original[0]', original[0])

                const updatedPost = await API.graphql({
                    query: mutations.updateCertificatedSubRequestTransactionCycle,
                    variables: {
                        input: {
                            id: original[0].id,
                            _version: original[0]._version,
                            status: 'REJECTED',
                            remark: rejectMsgValue,
                            customUpdatedAt: currentDateTime,
                            toEmpDesignation:toEmpDesignation
                        }
                    }
                });

                //#436 related start.
                if (updatedPost) {
                    //after rejection create new entry to transaction cycle start
                    // if (fallBackApprover?.type != 'Initiator') {
                    let createdRecord = await API.graphql(
                        graphqlOperation(mutations.createCertificatedSubRequestTransactionCycle, {
                            input: {
                                reportId: globalReportId,
                                from_Employee_Id: loggedUserId,
                                to_Employee_Id: fallBackApprover?.code,
                                status: 'OPEN',
                                isApproved: false,
                                approver_level: fallBackApprover?.type,
                                // customUpdatedAt: currentDateTime2,
                            }
                        })
                    );

                    console.log("cycle created-->", createdRecord)

                    // }

                }
                //#436 related end.

                await API.graphql({
                    query: mutations.updateCertificatedSubInitiateRequest,
                    variables: {
                        input: {
                            id: CertificatedSubInitiateRequestResponse.id,
                            _version: CertificatedSubInitiateRequestResponse._version,
                            status: 'APPROVAL_REJECTED'
                        }
                    }
                });
                console.log('original[0]=>updatedPost', updatedPost)

                await handleNotificationsOnStatusChangeforSubstituteRequestCertificated('REJECTED', globalReportId, "SUBSTITUTE_REQUEST_CERTIFICATED", createdBy, loggedUserId, rejectMsgValue, fallBackApprover.code);
                if (updatedPost.data.updateCertificatedSubRequestTransactionCycle.id) {
                    setSendMsg(true);
                }
            }
        }
        props.getMasterData();
    }

    //print report functionality
    const componentRef = useRef();
    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });
    //state
    const [reportInformation, setReportInformation] = useState([]);
    const [fundingDetails, setFundingDetails] = useState([]);
    const [showReport, setShowReport] = useState(false);
    const [requestApprovalConfirmVisible, setRequestApprovalConfirmVisible] = useState(false);
    const [requestRejectConfirmVisible, setRequestRejectConfirmVisible] = useState(false);
    const [sendMsg, setSendMsg] = useState(false);
    const [rejectMsgValue, setRejectValueMsg] = useState('');

    const clearRejectPopUpFields = () => {
        setFallBackApproverLevel(null);
        setFallBackApprover(null);
        setRejectValueMsg('');
    }

    const footerContentForReqReject = () => (
        <div className="mb-10 px-5 py-3 flex gap-2 justify-center">
            {
                (sendMsg)
                    ? <button className='bg-[#113699] border border-[##113699] text-white px-8 py-2 rounded'
                        onClick={() => {
                            props.getMasterData();
                            setRequestRejectConfirmVisible(false);
                            props.closePopUp();
                            setSendMsg(false);
                            setShowReport(false);
                        }}
                    >Ok</button>

                    : <button className='bg-[#113699] border border-[##113699] text-white px-8 py-2 rounded'
                        onClick={() => { rejectParticularReport(); clearRejectPopUpFields(); }}
                    >Send</button>
            }

            <button
                onClick={() => { setRequestRejectConfirmVisible(false); clearRejectPopUpFields(); }}
                className=" bg-white border border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-[#344054] flex items-center text-xs py-[6px] px-[10px] rounded-[8px] justify-center"
            >
                <i className="gusd-close-circle mr-1" style={{ fontSize: '1rem' }}></i>
                Cancel
            </button>

        </div>
    );

    useEffect(() => {
        getDateMeta()
    }, [props.specificReportDataForEdit])

    const getDateMeta = () => {

        const { reportId = '', schoolOrDeptName = '', requestDate = '', status = '', purpose = '', approvalFinalData = [], createdDate = '', showEditReportButton } = props.specificReportDataForEdit;

        setSchoolOrDeptName(schoolOrDeptName);
        setRequestDate(requestDate);
        setStatus(status);
        setStatus(status);
        setSpecifyPurpose(purpose);
        setCreatedDate(createdDate)
        setApprovalFinalData(approvalFinalData);
        if (reportId != '') {
            setReportId(reportId);
            getInformationOfParticularReport(reportId);
        }
    }

    const approveStatusOptions = (product) => {

        switch (product.status) {
            case 'Rejected':
                return 'danger';

            case 'Submitted':
                return 'info';

            case 'Pending':
                return 'warning';

            case 'Closed':
                return 'info';
            case 'Approved':
                return 'success';

            case 'Reviewed & resubmitted':
                return 'info'

            default:
                return null;
        }
    };



    //reject popup additional
    const [approverLevelForReject, setApproverLevelForReject] = useState([]);
    const [fallBackApproverLevel, setFallBackApproverLevel] = useState(null);
    const [approverListForReject, setApproverListForReject] = useState([]);
    const [fallBackApprover, setFallBackApprover] = useState(null);

    const getApprover = (e) => {
        setFallBackApproverLevel(e.value);
        if (e.value === 1) {
            let first = approverListForReject.filter(item => item.type === "Initiator");
            setFallBackApprover(first[0]);
        } else if (e.value === 2) {
            let first = approverListForReject.filter(item => item.type === "site/dept");
            setFallBackApprover(first[0]);
        } else if (e.value === 3) {
            let first = approverListForReject.filter(item => item.type === "budgetClerk");
            setFallBackApprover(first[0]);
        } else if (e.value === 4) {
            let first = approverListForReject.filter(item => item.type === "budgetManager");
            setFallBackApprover(first[0]);
        }
    }

    return (
        <>
            <Dialog className="relative reports-popup" visible={props.visibleRequestedReportEdit} position='right'
                style={{ width: '70vw' }} breakpoints={{ '960px': '75vw', '641px': '100vw' }} onHide={() => { props.closePopUp(); setShowReport(false); }} draggable={false} resizable={false}>
                <div className="grid grid-cols-2 lg:grid-cols-12 h-screen">
                    <div className="col-span-1 lg:col-span-8 bg-[#F5F6F7] h-auto">

                        {
                            (isLoadData) ?
                                <div className="p-5">
                                    <div onClick={() => { props.closePopUp(); setShowReport(false); }} className="py-3">
                                        <Image src={sideBarRight} alt="user" width="24" height="24" /></div>
                                    {
                                        (!showReport) ?
                                            <div>
                                                <div className="flex justify-between">
                                                    <div>
                                                        <div className="text-[#113699] text-md lg:text-[0.833vw] font-bold">Glendale Unified School District</div>
                                                        <div className="text-[#344054] text-xs lg:text-[0.625vw] font-medium">Substitute Request Certificated</div>
                                                    </div>

                                                    {
                                                         (props.certificatedSubReqIsPayroll != 1) ?
                                                         <button
                                                         onClick={() => {
                                                             // navigateTo('/substitute_request_certificated/initiate_new_report/' + globalReportId + "/" + status);
                                                             navigateTo('/substitute_request_certificated/initiate_new_report/' + globalReportId + "/" + "EditByAp");
                                                             navigateTo(0)
                                                         }}
                                                         className="border border-[#D0D5DD] bg-white shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                         <i className="mr-3 gusd-edit"></i><span className="xl:text-[14px]">{approveDisable === true ? 'Please wait' : "Edit Report"}</span>
                                                     </button>:<></>
                                                    }
                                                   
                                                </div>

                                                <div className="pt-3">
                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">School or Department </div>
                                                        <div className="font-semibold ">{schoolOrDeptName}</div>
                                                    </div>
                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Date </div>
                                                        <div className="font-semibold ">{requestDate}</div>
                                                    </div>

                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Status </div>
                                                        <Tag severity="" value={status} className="" style={{ background: '#EBFFF3', color: '#003D19' }}></Tag>
                                                    </div>
                                                </div>

                                                {
                                                    (reportInformation.length > 0) ?
                                                        // <div className="card">
                                                        //     <DataTable value={reportInformation}>
                                                        //         <Column field="teacherName" header="Teacher(s) Name" sortable ></Column>
                                                        //         <Column field="datesNeeded" header="Date(s) Needed" sortable ></Column>
                                                        //         <Column field="indicateIf" header="Indicate If" sortable ></Column>
                                                        //         <Column field="gradeOrSubject" header="Grade(element) or Subject(second)" sortable ></Column>
                                                        //         <Column field="notes" header="Notes" sortable ></Column>
                                                        //     </DataTable>
                                                        // </div>


                                                        <Table className="certificatedPrintTable">
                                                            <TableHead>
                                                                <TableRow>
                                                                    <TableCell>Teacher(s) Name</TableCell>
                                                                    <TableCell>Date(s) Needed</TableCell>
                                                                    <TableCell>Indicate If</TableCell>
                                                                    <TableCell>Grade(element) or Subject(second)</TableCell>
                                                                    <TableCell>Notes</TableCell>
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>

                                                                {reportInformation.map((item, i) => (
                                                                    <Fragment>
                                                                        <TableRow>
                                                                            <TableCell className="bg-[#F2F4F7]"
                                                                            >
                                                                                {item.teacherName}
                                                                            </TableCell>
                                                                            <TableCell className="w-[180px]">
                                                                                {item.datesNeeded.map((date, detailIndex) => (

                                                                                    <TableRow className="bg-[#F2F4F7]">
                                                                                        <TableCell>{moment(date).format('MM/DD/YYYY')}</TableCell>
                                                                                    </TableRow>
                                                                                ))}
                                                                            </TableCell>
                                                                            <TableCell className="bg-[#F2F4F7]"
                                                                            >
                                                                                {item.indicateIf}
                                                                            </TableCell>
                                                                            <TableCell className="bg-[#F2F4F7]"
                                                                            >
                                                                                {item.gradeOrSubject}
                                                                            </TableCell>
                                                                            <TableCell className="bg-[#F2F4F7]"
                                                                            >
                                                                                {item.notes}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    </Fragment>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                        : null
                                                }


                                                <div className="pt-3">
                                                    <div className="flex justify-between text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Purpose</div>
                                                        <div className="font-semibold ">{specifyPurpose}</div>
                                                    </div>
                                                    <div className="text-[#344054] text-[12px] py-[0.729vw] px-[0.417vw] border-b border-[#E4E7EC]">
                                                        <div className="font-medium">Funding Account</div>

                                                        {
                                                            fundingDetails.map((currentItem) => {
                                                                return (
                                                                    <div className="border p-2">
                                                                        <div className="flex justify-between">
                                                                            <div className="font-light py-3">Department</div>
                                                                            <div className="font-semibold ">{currentItem.departmentName}</div>
                                                                        </div>

                                                                        <div className="flex justify-between">
                                                                            <div className="font-light py-3">Remark</div>
                                                                            <div className="font-semibold ">{currentItem.remark ? currentItem.remark : '-'}</div>
                                                                        </div>
                                                                        <div className="flex justify-between">
                                                                            <div className="font-light">Program Account #</div>
                                                                            <div className="font-semibold ">{currentItem.programAccountNumber}</div>
                                                                        </div>
                                                                        <div className="flex justify-between">
                                                                            <div className="font-light">Percentage</div>
                                                                            <div className="font-semibold ">{currentItem.percentage}</div>
                                                                        </div>

                                                                    </div>
                                                                );
                                                            })
                                                        }

                                                    </div>
                                                </div>
                                            </div>
                                            :
                                            <div>
                                                <ReportTemplate
                                                    submittedBy={submittedBy}
                                                    schoolOrDeptName={schoolOrDeptName}
                                                    requestDate={requestDate}
                                                    status={status}
                                                    reportInformation={reportInformation}
                                                    fundingDetails={fundingDetails}
                                                    specifyPurpose={specifyPurpose}
                                                    approvalFinalData={approvalFinalData}
                                                    createdDate={createdDate}
                                                    events={events}
                                                />
                                            </div>
                                    }

                                    {
                                        (props.certificatedSubReqIsPayroll == 1) ?
                                            <div className='grid grid-cols-3 gap-4'>

                                                <button
                                                    onClick={() => { props.closePopUp(); setShowReport(false); }}
                                                    className="border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-close-circle"></i><span className="xl:text-[14px]">Cancel</span>
                                                </button>

                                                <button
                                                    onClick={() => setRequestRejectConfirmVisible(true)}
                                                    className="border text-[red] mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center py-[10px] px-[8px] rounded-[8px] justify-center ">
                                                    <i className="mr-3 gusd-close"></i><span className="xl:text-[14px]">Reject</span>
                                                </button>

                                                <button
                                                    onClick={() => { setShowReport(true); approveParticularReport(); }}
                                                    className="bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-white flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-document"></i><span>Acknowledge Report</span>
                                                </button>

                                            </div>
                                            :
                                            <div className='lg:flex justify-between gap-4 mt-10 md:block'>

                                                <button
                                                    onClick={() => { props.closePopUp(); setShowReport(false); }}
                                                    className="w-full border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-close-circle"></i><span className="xl:text-[14px]">Cancel</span>
                                                </button>


                                                <button
                                                    onClick={() => setRequestRejectConfirmVisible(true)}
                                                    className="w-full border text-[red] mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-close"></i><span className="xl:text-[14px]">Reject</span>
                                                </button>

                                                {
                                                    (props.showEditReportButton) ?
                                                        <button
                                                            onClick={() => {
                                                                navigateTo('/substitute_request_certificated/initiate_new_report/' + globalReportId + "/" + status);
                                                                navigateTo(0)
                                                            }}
                                                            className="w-full border text-[blue] mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                            <i className="mr-3 gusd-check "></i><span className="xl:text-[14px]">{approveDisable === true ? 'Please wait' : "Edit Report"}</span>
                                                        </button> : null
                                                }

                                                <button
                                                    onClick={() => approveParticularReport()}
                                                    disabled={approveDisable === true ? true : false}
                                                    className="w-full border text-[green] mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                    <i className="mr-3 gusd-check "></i><span className="xl:text-[14px]">{approveDisable === true ? 'Please wait' : "Approve"}</span>
                                                </button>

                                                {
                                                    (showReport) ?
                                                        <button onClick={handlePrint} className="w-full bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-white flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                            <i className="mr-2 gusd-print-outline"></i><span className="xl:text-[13px]">Print / Download</span>
                                                        </button> :

                                                        <button
                                                            onClick={() => setShowReport(true)}
                                                            className="w-full bg-[#113699] border mt-10 border-[#D0D5DD] shadow-[0px_1px_2px_rgba(16,24,40,0.05)] font-medium text-white flex items-center py-[10px] px-[8px] rounded-[8px] justify-center">
                                                            <i className="mr-3 gusd-document"></i><span>Show Report</span>
                                                        </button>
                                                }

                                            </div>
                                    }


                                    {/* print report template */}
                                    <div style={{ display: "none" }} >
                                        <div ref={componentRef}>
                                            <ReportTemplate
                                                submittedBy={submittedBy}
                                                schoolOrDeptName={schoolOrDeptName}
                                                requestDate={requestDate}
                                                status={status}
                                                reportInformation={reportInformation}
                                                fundingDetails={fundingDetails}
                                                specifyPurpose={specifyPurpose}
                                                approvalFinalData={approvalFinalData}
                                                createdDate={createdDate}
                                            />
                                        </div>
                                    </div>
                                    {/* Dialog:approve confirmation */}
                                    <Dialog header="" visible={requestApprovalConfirmVisible} style={{ width: '30vw' }} onHide={() => { setRequestApprovalConfirmVisible(false); props.closePopUp(); setShowReport(false); }}>
                                        <p className="m-0 text-[#0487C8] text-center">
                                            <i className='pi pi-check-circle mr-2'></i>
                                            <span className='font-medium text-[18px]'>This report was Approved</span>
                                        </p>
                                        <div className='text-center'>
                                            <button className='border border-[#1E1E1E] text-[#1E3E5A] px-4 py-2 rounded' onClick={() => {
                                                // BindList();
                                                setRequestApprovalConfirmVisible(false);
                                                props.closePopUp();
                                                setShowReport(false);
                                                props.BindList();

                                            }}>Close</button>
                                        </div>
                                    </Dialog>
                                    {/* Dialog:reject confirmation */}
                                    <Dialog
                                        header="Reject Report"
                                        visible={requestRejectConfirmVisible}
                                        style={{ width: '30vw' }}
                                        onHide={() => { setRequestRejectConfirmVisible(false); clearRejectPopUpFields();/* setVisibleEdit(false); */ }}
                                        footer={footerContentForReqReject}
                                    >
                                        <div className="m-0">
                                            {
                                                (!sendMsg) ?
                                                    <>

                                                        {/* #436 UI start */}
                                                        <div className="text-[#344054] font-medium text-[14px] mb-1">
                                                            Select an approver level<span className="text-[red] pl-0.2">*</span>
                                                        </div>
                                                        <Dropdown
                                                            value={fallBackApproverLevel}
                                                            options={approverLevelForReject}
                                                            onChange={e => {
                                                                getApprover(e);
                                                            }}
                                                            optionLabel="label"
                                                            placeholder="Select"
                                                            className="p-column-filter custDropdown w-full mb-6"
                                                        />

                                                        <div className="text-[#344054] font-medium text-[14px] mb-1">
                                                            Select an approver<span className="text-[red] pl-0.2">*</span>
                                                        </div>
                                                        <Dropdown
                                                            value={fallBackApprover}
                                                            disabled
                                                            options={approverListForReject}
                                                            onChange={e => setFallBackApprover(e.value)}
                                                            optionLabel="name"
                                                            placeholder="Select"
                                                            className="p-column-filter custDropdown w-full mb-6"
                                                            filter
                                                        />
                                                        {/* #436 UI end */}




                                                        <div className='font-medium text-[18px] mb-6'>Enter the Reason for Rejection<span className="text-[red] pl-0.2">*</span></div>
                                                        <InputText value={rejectMsgValue} placeholder="Enter the Reason for Rejection" onChange={(e) => setRejectValueMsg(e.target.value)} className="w-full" />
                                                    </> :
                                                    <div className='font-medium text-[18px] text-[#249144] mb-6'>Message sent successfully.</div>
                                            }
                                        </div>
                                    </Dialog>
                                </div>
                                :
                                <div className="card flex justify-content-center">
                                    <ProgressSpinner />
                                </div>
                        }
                    </div>

                    <div className="col-span-1 lg:col-span-4 bg-[#EFF0F1] h-auto">
                        <div className="p-5">
                            <div className="text-[#344054] text-[16px] font-medium py-3 mb-5">Form History</div>

                            <div className="card custTable">

                                <Timeline value={events}
                                    opposite={(item) => <Tag
                                        severity={approveStatusOptions(item)} className="mr-2 relative top-[-5px]"
                                        value={item.status}></Tag>} content={(item, i) => <div className="relative top-[-10px]">
                                            <div className="text-[#667085] text-[12px] ml-2">Step {i + 1}</div>
                                            <small className="xl:text-[0.729vw] text-[14px] font-semibold text-[#113699] leading-tight ml-2">{item.empTitle}</small>
                                            <div className="text-color-secondary text-xs ml-2">{item.empName}</div>
                                            <div className="text-color-secondary text-[9px] ml-2">{item.date}</div>

                                        </div>} />

                            </div>
                        </div>
                    </div>
                </div>
            </Dialog >
        </>
    )
}

export default EditPopupRequestedReport